import { createReducerState } from '../sharedConfig/createReducerState';

export const changeIntroductionStateAction = createReducerState({
  options: {},
  property: 'navigation.showIntroduction',
  prefix: 'CHANGE_INTRODUCTION_STATE',
  initial: true,
});
export const changeIntermediateTextStateAction = createReducerState({
  options: {},
  property: 'navigation.showIntermediateText',
  prefix: 'CHANGE_INTERMEDIATE_TEXT_STATE',
  initial: true,
});

export const changeEndOfDiagnosticStateAction = createReducerState({
  options: {},
  property: 'navigation.endOfDiagnostic',
  prefix: 'CHANGE_END_OF_DIAGNOSTIC_STATE',
  initial: false,
});
